import React from 'react';
import { formatCurrency, formatDateTime } from '../../utils/formatters';
import '../../styles/debt-payment-history.css';

const DebtPaymentHistory = ({ payments }) => {
  if (!payments || payments.length === 0) {
    return (
      <div className="no-payments">
        <p>No payments recorded yet</p>
      </div>
    );
  }

  return (
    <div className="payment-history">
      <table className="payments-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Method</th>
            <th>Reference</th>
            <th>Collected By</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment, index) => (
            <tr key={index}>
              <td>{formatDateTime(payment.payment_date)}</td>
              <td className="amount">{formatCurrency(payment.amount)}</td>
              <td>
                <span className={`method-badge ${payment.payment_method}`}>
                  {payment.payment_method}
                </span>
              </td>
              <td>{payment.transaction_code || payment.reference_number || '-'}</td>
              <td>{payment.collected_by_first} {payment.collected_by_last}</td>
              <td>{payment.notes || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="payment-summary">
        <div className="summary-item">
          <span>Total Payments:</span>
          <strong>{payments.length}</strong>
        </div>
        <div className="summary-item">
          <span>Total Amount:</span>
          <strong>
            {formatCurrency(payments.reduce((sum, p) => sum + p.amount, 0))}
          </strong>
        </div>
      </div>
    </div>
  );
};

export default DebtPaymentHistory;